import React, { Fragment, useContext, useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import * as Io from "react-icons/io";
import * as Fa from "react-icons/fa";
import * as Md from "react-icons/md";

import TodaysEnquiries from "./TodaysEnquiries";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import PendingEnquiries from "./PendingEnquiries";
import ConfirmedEnquiries from "./ConfirmedEnquiries";
import CancelledEnquiries from "./CancelledEnquiries";
import EnquiriesHistory from "./EnquiriesHistory";

import "../../styles/style.css";
import Breadcrumb from "../Breadcrumb";

function EnquiriesList() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const {
    recentEnquiries,
    reservationLoading,
    fetchNewReservations,
    fetchReservationHistory,
    fetchFutureReservations,
    upcomingwithtodaysReservationList,
    fetchAllTables,
  } = useContext(AppContext);
  const [confirmedList, setConfirmedList] = useState(null);
  const [pendingList, setpendingList] = useState(null);
  const [modifiedEnquiries, setModifiedEnquiries] = useState(null);
  const [cancelledEnquiries, setCancelledEnquiries] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [searchWord, setSearchWord] = useState("");
  const [searchDate, setSearchDate] = useState("");

  useEffect(() => {
    filterEnquiries();
  }, [recentEnquiries]);

  useEffect(() => {
    const tabIndex = sessionStorage.getItem("tab");
    const tabValue = queryParams.get("tab");
    const dateParam =
      queryParams.get("date") || sessionStorage.getItem("enquirySearchDate");

    if (dateParam) {
      setSearchDate(dateParam);
      sessionStorage.removeItem("enquirySearchDate");
    }

    if (tabValue) {
      const value = typeof tabValue == "string" ? parseInt(tabValue) : tabValue;
      setActiveTab(value);
      return;
    }
    if (tabIndex) {
      const parser =
        typeof tabIndex == "string" ? parseInt(tabIndex) : tabIndex;

      setActiveTab(parser);
      sessionStorage.removeItem("tab");
    }
  }, []);

  const fetchAllBookinGdetails = async () => {
    const shopToken = window.localStorage.getItem("shopCustomToken");

    if (!shopToken) return;

    await fetchNewReservations(shopToken);
    await fetchReservationHistory(shopToken);
    await fetchFutureReservations(shopToken);
    await upcomingwithtodaysReservationList(shopToken);
    await fetchAllTables(shopToken);
  };

  const filterEnquiries = () => {
    if (!recentEnquiries) return;

    const mergedEnquiries = recentEnquiries?.enquiries
      .concat(recentEnquiries?.modified_enquiries)
      .sort((a, b) => a.id - b.id);

    if (recentEnquiries?.enquiries) {
      const pendings =
        Array.isArray(mergedEnquiries) && mergedEnquiries.length > 0
          ? mergedEnquiries.reverse()
          : [];

      const approved =
        Array.isArray(recentEnquiries?.enquiries) &&
        recentEnquiries?.enquiries.length > 0
          ? recentEnquiries.enquiries
              .filter((data) => {
                if (data?.status === "Approved") {
                  return data;
                }
              })
              .reverse()
          : [];
      setpendingList(pendings);
      setConfirmedList(approved);
      setCancelledEnquiries(recentEnquiries?.today_cancelled_enquiries);
    }
    if (recentEnquiries?.modified_enquiries) {
      setModifiedEnquiries(recentEnquiries?.modifiedEnquiries);
    }
    if (recentEnquiries?.today_cancelled_enquiries) {
      setCancelledEnquiries(recentEnquiries?.today_cancelled_enquiries);
    }
  };

  const handleActiveTab = (index) => {
    setActiveTab(index);
    sessionStorage.setItem("tab", index);
    queryParams.delete("tab");
    // Today's tab has no date filter
    if (index === 0) setSearchDate("");
    navigate("/table-enquiry-list", { replace: true });
  };

  const openDatePicker = (e) => {
    const input = e.currentTarget;
    if (typeof input.showPicker === "function") {
      try {
        input.showPicker();
      } catch {
        /* ignore — browser may block if not a direct gesture */
      }
    }
  };

  const dateLabel = searchDate
    ? new Date(`${searchDate}T00:00:00`).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "All dates";

  return (
    <Fragment>
      <Breadcrumb pageTitle="Reservations" title="Reservation List" />
      <div className="card h-100 radius-12 enquiries-list">
        <div className="card-body p-24 enquiries-list__body">
          <div className="el-toolbar">
            <form
              className="el-search navbar-search position-relative"
              id="item-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <Icon icon="ion:search-outline" className="icon el-search__icon" />
              <input
                type="text"
                className="form-control el-search__input"
                name="search"
                placeholder="Name, email, phone or ID"
                onChange={(e) => setSearchWord(e.target.value)}
                value={searchWord}
              />
              {searchWord && searchWord.length != 0 && (
                <i className="close_sm_btn" onClick={() => setSearchWord("")}>
                  <Io.IoMdCloseCircle />
                </i>
              )}
            </form>

            {activeTab !== 0 && (
              <label className="el-date">
                <Md.MdOutlineCalendarToday
                  className="el-date__icon"
                  aria-hidden
                />
                <span className="el-date__label">{dateLabel}</span>
                <input
                  type="date"
                  className="el-date__input"
                  onChange={(e) => setSearchDate(e.target.value)}
                  onClick={openDatePicker}
                  value={searchDate}
                  aria-label="Filter by date"
                />
                {searchDate ? (
                  <button
                    type="button"
                    className="el-date__clear"
                    aria-label="Clear date"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSearchDate("");
                    }}
                  >
                    <Io.IoMdClose />
                  </button>
                ) : (
                  <Io.IoIosArrowDown
                    className="el-date__chevron"
                    aria-hidden
                  />
                )}
              </label>
            )}

            <button
              type="button"
              className={
                !reservationLoading
                  ? "el-refresh refresh_btn"
                  : "el-refresh refresh_btn rotate"
              }
              disabled={reservationLoading}
              onClick={fetchAllBookinGdetails}
              aria-label="Refresh"
            >
              <Io.IoMdRefresh />
              <span className="el-refresh__label">Refresh</span>
            </button>
          </div>

          <div className="position-relative enquiries-list__tabs">
            <Tabs
              selectedIndex={activeTab}
              onSelect={(tabIndex) => handleActiveTab(tabIndex)}
            >
              <TabList className="el-tabs">
                <Tab className="el-tab" selectedClassName="el-tab is-active">
                  <i>
                    <Fa.FaRegCalendarPlus />
                  </i>
                  Today's
                </Tab>
                <Tab className="el-tab" selectedClassName="el-tab is-active">
                  <i>
                    <Fa.FaRegCalendarMinus />
                  </i>
                  Pending
                </Tab>
                <Tab className="el-tab" selectedClassName="el-tab is-active">
                  <i>
                    <Fa.FaRegCalendarCheck />
                  </i>
                  Approved
                </Tab>
                <Tab className="el-tab" selectedClassName="el-tab is-active">
                  <i>
                    <Fa.FaRegCalendarTimes />
                  </i>
                  Cancelled
                </Tab>
                <Tab className="el-tab" selectedClassName="el-tab is-active">
                  <i>
                    <Fa.FaRegCalendarAlt />
                  </i>
                  History
                </Tab>
              </TabList>
              <TabPanel>
                <TodaysEnquiries
                  activeTab={activeTab}
                  keyword={searchWord}
                  setSearchWord={setSearchWord}
                />
              </TabPanel>
              <TabPanel>
                <PendingEnquiries
                  pendingList={pendingList}
                  activeTab={activeTab}
                  keyword={searchWord}
                  searchDate={searchDate}
                  setSearchWord={setSearchWord}
                />
              </TabPanel>
              <TabPanel>
                <ConfirmedEnquiries
                  approvedList={confirmedList}
                  activeTab={activeTab}
                  keyword={searchWord}
                  searchDate={searchDate}
                  setSearchWord={setSearchWord}
                />
              </TabPanel>
              <TabPanel>
                <CancelledEnquiries
                  cancelledEnquiries={cancelledEnquiries}
                  activeTab={activeTab}
                  keyword={searchWord}
                  searchDate={searchDate}
                  setSearchWord={setSearchWord}
                />
              </TabPanel>
              <TabPanel>
                <EnquiriesHistory
                  keyword={searchWord}
                  searchDate={searchDate}
                  setSearchWord={setSearchWord}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default EnquiriesList;
